import { Box, ButtonNew, Spacer } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { useNavigation } from '@react-navigation/native'
import { useCallback, useEffect } from 'react'
import { ToastPosition, ToastType } from '../../../../comps/Toast'
import { RootStore, useLazyApiData, useStores } from '../../../../data/store'
import { shadowStyle } from '../../../../util/util'
import { hasDataChanged, parseFormData } from './FormDataParser'

const onSubmitPress = (hitAddEditUserApi: any) => {
  hitAddEditUserApi()
  //navigation?.navigate(Routes.SETTINGS)
}

export const RenderActionButtons = ({
  isValid,
  values,
  isEditScreen,
  previousFormData,
  mid,
  jfsUserId,
  screenName,
  borderTopColor,
}: any) => {
  const navigation = useNavigation()
  const { addEditUserApi, refreshUserManagementTable, refreshTable, hasSupersetPermission, selectedMid, merchants } = useStores((store) => ({
    addEditUserApi: store.userManagement.addEditUserApi,
    refreshUserManagementTable: store.userManagement.refreshUserManagementTable,
    refreshTable: store.userManagement.refreshTable,
    hasSupersetPermission: store.userManagement.hasSupersetPermission(),
    selectedMid: store.user.selectedMid,
    merchants: store.user.merchants
  }))

  const [addEditUser, addEditUserHandler = { data: [], state: undefined }] = useLazyApiData(addEditUserApi)

  const isUserRoleSelected = useCallback(() => {
    if (isEditScreen || hasSupersetPermission) {
      return true
    } else {
      return values?.role !== undefined && values?.role?.length > 1
    }
  }, [hasSupersetPermission, isEditScreen, values?.role])

  useEffect(() => {
    if (addEditUserHandler.state === 'fulfilled') {
      if (isEditScreen) {
        RootStore?.response?.setCustomToast({
          message: 'Changes have been saved',
          color: defaultColors.GREEN,
          position: ToastPosition.TOP,
          toastType: ToastType.POSITIVE,
          minWidthOfLeftBox: 200,
        })
      } else {
        RootStore?.response?.setCustomToast({
          message: 'User Added Successfully',
          color: defaultColors.GREEN,
          position: ToastPosition.TOP,
          toastType: ToastType.POSITIVE,
          minWidthOfLeftBox: 200,
        })
      }
      navigation?.navigate({ name: screenName } as never)
      //To update store for refreshing the table in previous screen, wont use state as it will lead to un necessary re render.
      refreshUserManagementTable(!refreshTable)
    }
    //NOTE: We don't need dependency of refreshTable because it will lead to re call of this use effect hook because store will change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addEditUserHandler.state, isEditScreen, navigation, refreshUserManagementTable])

  const hitAddEditUserApi = () => {
    const merchantType = merchants?.find(item => item.mid === selectedMid)?.type ?? 'MERCHANT'
    const parsedData = parseFormData(values, previousFormData, isEditScreen, mid, jfsUserId, merchantType)

    addEditUser(isEditScreen, parsedData)
  }

  return (
    <Box
      borderTopWidth={1}
      borderTopColor={borderTopColor ?? 'BORDER_COLOR'}
      marginTop={10}
      paddingTop={20}
      flexDirection="row"
      justifyContent="flex-end">
      <ButtonNew
        testID="calcel-add-user"
        title="Cancel"
        onPress={() => navigation?.navigate({ name: screenName } as never)}
        type="secondarySmall"
        {...shadowStyle}
        borderColor="GREY_SEPARATOR"
        borderRadius={4}
      />
      <Spacer direction="horizontal" size={20} />
      <ButtonNew
        testID="submit-add-user"
        disabled={
          (!isValid && !isEditScreen) ||
          !isUserRoleSelected() ||
          (isEditScreen && !hasDataChanged(values, previousFormData))
        }
        title={isEditScreen ? 'Save Changes' : 'Add User'}
        isLoading={addEditUserHandler.state === 'pending'}
        onPress={() => onSubmitPress(hitAddEditUserApi)}
        type="primarySmall"
        {...shadowStyle}
        borderRadius={4}
      />
    </Box>
  )
}
